// Features that no plan restricts, so every school gets them from the Free plan upwards.
// They have no accountfeatures row (the plans API does not return them), so the plan cards and
// comparison table add them here. If one is later given a minimum tier, remove it from this list
// and add its accountfeatures row instead. Mirrored in impatasite (models/included-features.ts).
export interface IncludedFeature {
  name: string;
  description: string;
  // Comparison table tab the row is shown under.
  tab: string;
}

export const INCLUDED_FEATURES: IncludedFeature[] = [
  { name: 'Live lessons', description: 'Run live classes online, with attendance and recordings', tab: 'Teaching' },
  { name: 'SCORM packages', description: 'Upload and play SCORM course packages', tab: 'Teaching' },
  { name: 'Lesson games', description: 'Add interactive games to your lessons', tab: 'Teaching' },
  { name: 'Course batches', description: 'Run a course in dated cohorts', tab: 'Teaching' },
  { name: 'Discussion forum', description: 'Course discussions for students and tutors', tab: 'Teaching' },
  { name: 'Offline downloads', description: 'Students can download lessons and video to use without internet', tab: 'Teaching' },
  { name: 'Certificates', description: 'Certificates are issued and emailed when a student completes a course', tab: 'Assessments' },
  { name: 'Course packages', description: 'Sell several courses together as one package', tab: 'Money & integrations' },
];
